import { useEffect, useState } from 'react';
import { useApiGateway } from 'hooks/useApi';

interface RiskFreeRates {
  '1m': number;
  '2m': number;
  '3m': number;
  '6m': number;
  '1y': number;
  '2y': number;
}

interface RiskFreeRatesResponse {
  rates: RiskFreeRates;
  lastUpdated: string;
}

export const useRiskFreeRates = (isOpen: boolean) => {
  const [rates, setRates] = useState<RiskFreeRates | null>(null);
  const { get, isLoading } = useApiGateway<never, RiskFreeRatesResponse>('v1/risk-free-rates');

  useEffect(() => {
    if (isOpen && !rates) {
      get()
        .then(({ data, isError }) => {
          if (!isError && data && typeof data !== 'string' && data.rates) {
            setRates(data.rates);
          }
        })
        .catch((error) => {
          console.error('Error fetching risk-free rates:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, rates]);

  return {
    rates,
    loading: isLoading,
  };
};

